<template>
  <page>
    <div v-if="renderAppType">
      <v-subheader>
        {{labels.appID}}
      </v-subheader>
      <v-container fluid grid-list-lg class="mb-3">
        <v-layout row wrap>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['motorQuoteUpdateStatus'])">
            <v-card :class="isMatchRoute('motorQuoteUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'motorQuoteUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MOTOR}}</v-icon>
                <span>Motor</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['travelQuoteUpdateStatus'])">
            <v-card :class="isMatchRoute('travelQuoteUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'travelQuoteUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.TRAVEL}}</v-icon>
                <span>Travel</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['fireQuoteUpdateStatus'])">
            <v-card :class="isMatchRoute('fireQuoteUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'fireQuoteUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.FIRE}}</v-icon>
                <span>Fire</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['paQuoteUpdateStatus'])">
            <v-card :class="isMatchRoute('paQuoteUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'paQuoteUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PA}}</v-icon>
                <span>Personal Accident</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoQuoteUpdateStatus'])">
            <v-card :class="isMatchRoute('cargoQuoteUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'cargoQuoteUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.CARGO}}</v-icon>
                <span>Cargo</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['maidQuoteUpdateStatus'])">
            <v-card :class="isMatchRoute('maidQuoteUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'maidQuoteUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MAID}}</v-icon>
                <span>Maid</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['packageQuoteUpdateStatus'])">
            <v-card :class="isMatchRoute('packageQuoteUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'packageQuoteUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PACKAGE}}</v-icon>
                <span>Package</span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view ></router-view>
      </transition>
    </div>
    <v-navigation-drawer temporary fixed clipped right app v-model="lifeCycle" width="400">
      <life-cycle query></life-cycle>
    </v-navigation-drawer>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import routeMixin from '@/mixins/route'
import LifeCycle from './LifeCycle'
import { appIcon } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        appID: 'Application Type'
      },
      lifeCycle: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    updateStatusState() {
      return this.$store.state.agency.updateStatus
    },
    renderAppType() {
      if (this.isMatchRouteExact('quoteUpdateStatus')) {
        return true
      } else {
        return false
      }
    },
    showStatusBtn() {
      // We only want to show at query page
      if (this.isMatchRouteExact('quoteUpdateStatus') ||
        this.isMatchRouteExact('motorQuoteUpdateStatus') ||
        this.isMatchRouteExact('fireQuoteUpdateStatus') ||
        this.isMatchRouteExact('cargoQuoteUpdateStatus') ||
        this.isMatchRouteExact('travelQuoteUpdateStatus') ||
        this.isMatchRouteExact('paQuoteUpdateStatus') ||
        this.isMatchRouteExact('maidQuoteUpdateStatus') ||
        this.isMatchRouteExact('packageQuoteUpdateStatus')) {
        return false
      } else {
        return true
      }
    },
    appIcon() {
      return appIcon
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('agencyQuoteUpdateStatusInit')
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    routeMixin
  ],
  components: {
    LifeCycle
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/agency.scss";
</style>
